import {token} from "@atlaskit/tokens";
import type {CSSProperties} from "react";

export const NOTES_PANEL_TITLE_STYLE: CSSProperties = {
    color: token("color.text"),
    fontFamily: "Inter, system-ui, -apple-system, BlinkMacSystemFont, sans-serif",
    fontSize: "var(--Font-Size-Heading-L, 24px)",
    fontStyle: "normal",
    fontWeight: "var(--Font-Weight-Heading, 653)",
    lineHeight: "var(--Line-Height-Heading-L, 28px)",
};

export const NOTES_ADD_NOTE_LABEL_STYLE: CSSProperties = {
    color: token("color.text.subtle"),
    fontFeatureSettings: "'liga' off, 'calt' off",
    fontFamily: "Inter, system-ui, -apple-system, BlinkMacSystemFont, sans-serif",
    fontSize: "var(--Font-Size-Body-S, 12px)",
    fontStyle: "normal",
    fontWeight: "var(--Font-Weight-Body-Bold, 653)",
    lineHeight: "var(--Line-Height-Body-S, 16px)",
};

export const NOTES_COMPOSER_BOX_STYLE: CSSProperties = {
    borderRadius: "3px",
    background: token("color.background.input"),
    border: `1px solid ${token("color.border")}`,
};

export const NOTES_FEED_BODY_TEXT_STYLE: CSSProperties = {
    color: token("color.text"),
    fontFeatureSettings: "'liga' off, 'calt' off",
    fontFamily: "Inter, system-ui, -apple-system, BlinkMacSystemFont, sans-serif",
    fontSize: "var(--Font-Size-Body-M, 14px)",
    fontStyle: "normal",
    fontWeight: "var(--Font-Weight-Body-Bold, 653)",
    lineHeight: "var(--Line-Height-Body-M, 20px)",
};

export function notesFeedBodyTruncateStyle(): CSSProperties {
    return {
        ...NOTES_FEED_BODY_TEXT_STYLE,
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: 1,
        overflow: "hidden",
        textOverflow: "ellipsis",
    };
}

export function NotesPanelTitle() {
    return <span style={NOTES_PANEL_TITLE_STYLE}>Notes</span>;
}

export function NotesAddNoteLabel() {
    return <span style={NOTES_ADD_NOTE_LABEL_STYLE}>Add note</span>;
}

const NOTES_PREVIOUS_NOTES_LABEL_STYLE: CSSProperties = {
    color: token("color.text"),
    fontFamily: "Inter, system-ui, -apple-system, BlinkMacSystemFont, sans-serif",
    fontSize: "var(--Font-Size-Body-M, 14px)",
    fontStyle: "normal",
    fontWeight: "var(--Font-Weight-Body-Bold, 653)",
    lineHeight: "var(--Line-Height-Body-M, 20px)",
};

export function NotesPreviousNotesLabel() {
    return <span style={NOTES_PREVIOUS_NOTES_LABEL_STYLE}>Previous Notes</span>;
}
